<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :viewBox="viewBox"
  >
    <g data-name="グループ 11764">
      <g data-name="グループ 11763">
        <path
          data-name="パス 4911"
          d="M512 464a12 12 0 1 1 12-12 12.014 12.014 0 0 1-12 12zm0-22.5a10.5 10.5 0 1 0 10.5 10.5 10.512 10.512 0 0 0-10.5-10.5z"
          transform="translate(-500 -440)"
          :style="{ fill: color }"
        />
      </g>
      <path
        data-name="パス 4912"
        d="M514.5 458a.749.749 0 0 1-.75-.75v-3a.749.749 0 0 1 .75-.75 3 3 0 1 0-3-3 .75.75 0 0 1-1.5 0 4.5 4.5 0 1 1 5.25 4.438v2.312a.749.749 0 0 1-.75.75z"
        transform="translate(-502.5 -441.5)"
        :style="{ fill: color }"
      />
      <path
        data-name="パス 4913"
        d="M515.75 465.5a.787.787 0 0 1-.533-.217.761.761 0 0 1 0-1.065.753.753 0 1 1 .533 1.282z"
        transform="translate(-503.75 -446.003)"
        :style="{ fill: color }"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'HelpSVG',
  props: {
    size: {
      type: String,
      default: '16px',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    color: {
      type: String,
      default: '#666666',
    },
  },
};
</script>
